import graphqlClient from './client';
import gql from 'graphql-tag';

export const mutation = gql`
  mutation SendProspectEmail(
    $prospectId: ID!
    $subject: String!
    $message: String!
    $enableReplies: Boolean!
  ) {
    sendProspectEmail(
      prospectId: $prospectId
      subject: $subject
      message: $message
      enableReplies: $enableReplies
    ) {
      id
      subject
      message
      from
      to
      candidateId
      prospectId
      sentDate
    }
  }
` as any;

interface ProspectEmail {
  id: string;
  subject: string;
  message: string;
  from: string;
  to: string;
  candidateId: string;
  prospectId: string;
  sentDate: string;
}
interface ProspectEmailData {
  sendProspectEmail: ProspectEmail;
}

export declare interface ProspectEmailResult {
  data: ProspectEmailData;
}

const sendProspectEmail = async (
  prospectId: string,
  subject: string,
  message: string,
  enableReplies: boolean,
): Promise<any> => {
  const { data } = (await graphqlClient.mutate({
    variables: { prospectId, subject, message, enableReplies },
    mutation,
  })) as ProspectEmailResult;

  return {
    ...data.sendProspectEmail,
    isNew: true,
  };
};

export default sendProspectEmail;
